import { memoize } from 'lodash-es';

export default memoize((e) => {
  const mask = e.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  return !mask[2]
    ? mask[1]
    : `(${mask[1]}) ${mask[2]}${mask[3] ? `-${mask[3]}` : ''}`;
});
